export const MAGMA_EXTENDED = 'https://raw.githubusercontent.com/magma-protocol/tokenList/main/magma.json'

// export const COINGECKO = 'https://tokens.pancakeswap.finance/coingecko.json'
// export const PANCAKE_ETH_DEFAULT = 'https://tokens.pancakeswap.finance/pancakeswap-eth-default.json'
// export const PANCAKE_ETH_MM = 'https://tokens.pancakeswap.finance/pancakeswap-eth-mm.json'
// export const PANCAKE_BSC_MM = 'https://tokens.pancakeswap.finance/pancakeswap-bnb-mm.json'
// export const COINGECKO_ETH = 'https://tokens.coingecko.com/uniswap/all.json'
// export const CMC = 'https://tokens.pancakeswap.finance/cmc.json'

// export const ETH_URLS = []
export const BSC_URLS = [MAGMA_EXTENDED]

// List of official tokens list
export const OFFICIAL_LISTS = [MAGMA_EXTENDED]

export const UNSUPPORTED_LIST_URLS: string[] = []
export const WARNING_LIST_URLS: string[] = []

// lower index == higher priority for token import
export const DEFAULT_LIST_OF_LISTS: string[] = [...BSC_URLS]

// default lists to be 'active' aka searched across
export const DEFAULT_ACTIVE_LIST_URLS: string[] = [MAGMA_EXTENDED]
